import api from './client';

export interface SignInAccessRuleUser {
  id: string;
  email: string;
  name: string | null;
}

export interface SignInAccessRule {
  id: string;
  type: 'email' | 'domain';
  value: string;
  expiresAt: string | null;
  claimedAt: string | null;
  claimedProvider: 'google' | 'microsoft' | null;
  createdAt: string;
  createdByUser: SignInAccessRuleUser;
  claimedByUser: SignInAccessRuleUser | null;
}

export interface SignInAccessResponse {
  invitationRequired: boolean;
  rules: SignInAccessRule[];
  total: number;
  page: number;
  limit: number;
}

export interface DeniedSignInAttempt {
  id: string;
  email: string;
  provider: 'google' | 'microsoft';
  attemptCount: number;
  firstAttemptAt: string;
  lastAttemptAt: string;
}

export interface DeniedSignInAttemptsResponse {
  attempts: DeniedSignInAttempt[];
  total: number;
  page: number;
  limit: number;
}

export const signInAccessService = {
  list: async (page = 1, limit = 50, search?: string): Promise<SignInAccessResponse> => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (search) params.set('search', search);
    return api.get(`/admin/sign-in-access?${params.toString()}`);
  },
  updateSettings: async (invitationRequired: boolean): Promise<{ invitationRequired: boolean }> =>
    api.patch('/admin/sign-in-access/settings', { invitationRequired }),
  createRule: async (type: 'email' | 'domain', value: string, expiresAt: string | null): Promise<SignInAccessRule> =>
    api.post('/admin/sign-in-access/rules', { type, value, expiresAt }),
  deleteRule: async (id: string): Promise<void> =>
    api.delete(`/admin/sign-in-access/rules/${encodeURIComponent(id)}`),
  listDeniedAttempts: async (page = 1, limit = 50): Promise<DeniedSignInAttemptsResponse> => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    return api.get(`/admin/sign-in-access/denied-attempts?${params.toString()}`);
  },
  authorizeDeniedAttempt: async (id: string): Promise<void> =>
    api.post(`/admin/sign-in-access/denied-attempts/${encodeURIComponent(id)}/authorize`),
};